import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import RegistrationPage from './pages/RegistrationPage';
import ConfirmedPage from './pages/ConfirmedPage';
import PortalAreaPage from './pages/PortalAreaPage';
import AdminLoginPage from './pages/admin/AdminLoginPage';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCoursesPage from './pages/admin/AdminCoursesPage';
import AdminEditionsPage from './pages/admin/AdminEditionsPage';
import AdminEnrollmentsPage from './pages/admin/AdminEnrollmentsPage';
import AdminEnrollmentDetailPage from './pages/admin/AdminEnrollmentDetailPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminUserDetailPage from './pages/admin/AdminUserDetailPage';
import AdminEditionContentPage from './pages/admin/AdminEditionContentPage';
import Admin2FAPage from './pages/admin/Admin2FAPage';
import AdminCheckInPage from './pages/admin/AdminCheckInPage';
import AdminSpeakersPage from './pages/admin/AdminSpeakersPage';
import AdminManualEnrollPage from './pages/admin/AdminManualEnrollPage';
import AccessPage from './pages/AccessPage';
import KioskPage from './pages/KioskPage';
import SpeakerPortalPage from './pages/SpeakerPortalPage';

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/" element={<Navigate to="/register" replace />} />
      <Route path="/register" element={<RegistrationPage />} />
      <Route path="/register/:courseSlug" element={<RegistrationPage />} />
      <Route path="/confirmed" element={<ConfirmedPage />} />
      <Route path="/area" element={<PortalAreaPage />} />
      <Route path="/accesso" element={<AccessPage />} />
      <Route path="/kiosk" element={<KioskPage />} />
      <Route path="/speaker/:token" element={<SpeakerPortalPage />} />

      {/* Admin routes */}
      <Route path="/admin/login" element={<AdminLoginPage />} />
      <Route path="/admin" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="courses" element={<AdminCoursesPage />} />
        <Route path="editions" element={<AdminEditionsPage />} />
        <Route path="users" element={<AdminUsersPage />} />
        <Route path="users/:id" element={<AdminUserDetailPage />} />
        <Route path="enrollments" element={<AdminEnrollmentsPage />} />
        <Route path="enrollments/manual" element={<AdminManualEnrollPage />} />
        <Route path="enrollments/:id" element={<AdminEnrollmentDetailPage />} />
        <Route path="editions/:id/content" element={<AdminEditionContentPage />} />
        <Route path="speakers" element={<AdminSpeakersPage />} />
        <Route path="2fa" element={<Admin2FAPage />} />
        <Route path="check-in" element={<AdminCheckInPage />} />
      </Route>

      {/* Catch-all */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
